<template>
  <div>
    <!-- with icon left -->
    <div v-if="hasLeftIcon && !isLoading">
      <sd-icon :name="hasLeftIcon" />
      <span class="btn__content">
        <slot />
      </span>
    </div>

    <!-- with icon right -->
    <div v-else-if="hasRightIcon && !isLoading">
      <span class="btn__content">
        <slot />
      </span>
      <sd-icon :name="hasRightIcon" />
    </div>

    <!-- loading button -->
    <div v-else-if="isLoading">
      <span class="btn__animation">
        <span class="btn__dot" />
        <span class="btn__dot" />
        <span class="btn__dot" />
        <span class="sr-only">{{ loadingText }}</span>
      </span>
    </div>

    <!-- without icon -->
    <span v-else class="btn__content">
      <slot />
    </span>
  </div>
</template>

<script>
/**
 * @IMPORTANT THIS COMPONENT IS ONLY FOR INTERNAL USAGE! DON'T USE IT IN YOUR PROJECT!!!
 */
import sdIcon from "../icon";

export default {
  components: {
    sdIcon,
  },

  props: {
    hasLeftIcon: {
      type: String,
      default: "",
    },

    hasRightIcon: {
      type: String,
      default: "",
    },

    isLoading: {
      type: Boolean,
      default: false,
    },

    loadingText: {
      type: String,
      default: "wird geladen",
    },
  },
};
</script>
